import { window } from '../env/browser';

export default function getGlobalValue(
  path: string,
  { bind = false }: { bind?: boolean } = {}
): unknown {
  return path.split('.').reduce<unknown>((ref, part, i, arr) => {
    if (!ref) return undefined;
    const obj = ref as Record<string, unknown>;
    const nextRef = obj[part];
    if (bind && i === arr.length - 1 && typeof nextRef === 'function') {
      return (nextRef as (...args: unknown[]) => unknown).bind(obj);
    }
    return nextRef;
  }, window as unknown);
}
